export default function nestFilterGroup(filter) {
  filter.filterGroups = [
    {
      connector: 'Any',
      filterGroups: [...filter.filterGroups]
    }
  ];
  filter.connector = 'All';
}
